import "./Author.css";

function AuthorLoading() {
  return (
    <section id="author">
      <div className="author-container">
        <div className="shimmer author-skeleton-circle" />
        <div className="author-text">
          <div className="author-header">
            <div className="shimmer author-skeleton-name" />
            <div className="author-divider" />
          </div>
          <div className="shimmer author-skeleton-bio" />
        </div>
      </div>
    </section>
  );
}

export default AuthorLoading;
